import ReducersTooling from '../../../tooling/reducersTooling';

const initialState = {
  groupsFilter: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  emailHistory: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  sendReportFileToEmails: ReducersTooling.initialStates.getFetchTypeInitialState(),
  calculationUnitsFilter: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  calculationUnitsFilterEmail: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  calculationUnitsFilterEmailSearch: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  calculationUnitsFilterEmailSearchQuery: ReducersTooling.initialStates.getFetchTypeInitialState(),
  generateReportFiles: ReducersTooling.initialStates.getFetchTypeInitialState(),
  reportFilesHistory: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  deleteReportFile: ReducersTooling.initialStates.getFetchTypeInitialStateDelete(),
  downloadReportFile: ReducersTooling.initialStates.getFetchTypeInitialState()
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/reportFileAdmin/initialState.js